<script setup>
import { Banner } from '@dashhudson/dashing-ui/banner';
import { useDrawer } from '@dashhudson/dashing-ui/drawer';
import { computed } from 'vue';

import {
  MANAGE_USAGE_CLICK_LOCATION_GDI,
  mentionLimitBannerMessage,
  SOCIAL_LISTENING_DRAWERS,
} from '@/app/socialListening/constants';
import { useSocialListeningTopicsStore } from '@/stores/social-listening-topics';

const topicsStore = useSocialListeningTopicsStore();

const { launchDrawer } = useDrawer();

const showMentionLimitReachedBanner = computed(() => topicsStore.hasExceededMentionLimit);
const mentionLimitReachedBannerMessage = computed(() => {
  const mentionLimit = topicsStore.topicsUsage?.mentionsRollingLimit;
  const formattedLimit = mentionLimit?.toLocaleString();
  return mentionLimitBannerMessage(formattedLimit);
});

async function handleManageLimit() {
  await launchDrawer({
    name: SOCIAL_LISTENING_DRAWERS.MANAGE_TOPIC_LIMITS,
    props: {
      from: MANAGE_USAGE_CLICK_LOCATION_GDI.TOPIC,
    },
  });
}
</script>

<template>
  <Banner
    v-if="showMentionLimitReachedBanner"
    severity="warn"
    :message="mentionLimitReachedBannerMessage"
    call-to-action="Manage Limits"
    @action="handleManageLimit"
  />
</template>
